export default {"src":"/_next/static/media/logo.238b81c3.svg","height":24,"width":83};